import {
  select as _select, take,
} from 'redux-saga/effects';
import { type AppState } from '../../../store/app.store';

export const select = <TResult, TParams extends any[] = []>(selector: (state: AppState, ...args: TParams) => TResult, ...args: TParams) => _select(selector, ...args);

export function* waitForStateChange<TResult>(selector: (state: AppState) => TResult, expectedValue: TResult) {
  const result: TResult = yield select<TResult>(selector);

  if (result === expectedValue) {
    return;
  }

  while (true) {
    yield take('*');
    const result: TResult = yield select<TResult>(selector);
    if (result === expectedValue) {
      return;
    }
  }
}
